import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
// import name from "../../assets/images/resource/name.svg";
// import email from "../../assets/images/resource/email.svg";
// import Phone from "../../assets/images/resource/mobile-dev.svg";
// import company from "../../assets/images/resource/company.svg";
import NextBtn from "./nextbutton";
import Select from "react-select";
import { Country, State, City } from "country-state-city";

const StepFirst = ({
  handleStepChange,
  handleSubmit,
  handleSignup,
  register,
  errors,
  handleChange,
  check,
  setSelectedCountry,
  setSelectedState,
  setSelectedCity,
  selectedCountry,
  selectedState,
  selectedCity
}) => {
  
  useEffect(() => {
    console.log(selectedCountry);
    console.log(selectedCountry?.isoCode);
    console.log(State?.getStatesOfCountry(selectedCountry?.isoCode));
  }, [selectedCountry]);

  const customStyles = {
    option: (provided) => ({
      ...provided,
      background: "#fff",
      color: "#333",
      fontWeight: "500",
      fontSize: "16px",
      padding: "4px 10px",
      lineHeight: "24px",
      cursor: "pointer",
      ":hover": {
        background: "#FFBD60",
        borderRadius: 8,
      },
    }),
    menu: (provided) => ({
      ...provided,
      background: "#ffffff",
      padding: "15px",
    }),
    control: () => ({
      background: "#ffffff",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "0px 10px",
      color: "#333333",
      display: "flex",
      alignItem: "center",
      height: "65px",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      boxShadow: "0px 2px 6px rgba(19, 18, 66, 0.07)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
    }),
    errorStyle: (provided) => ({
      ...provided,
      border: "2px solid red",
    }),
  };

  return (
    <div className='resource-step-content'>
      <div className='resource-step-heading'>
        <h4>Contact details</h4>
        <p>Lorem ipsum dolor sit amet consectetur adipisc.</p>
      </div>
      <Form onSubmit={handleSubmit(handleSignup)}>
        <div className='resource-form-content'>
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Street Address</label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='streetAddres'
                  placeholder='Full Address'
                  className={errors.Name ? "error-field" : ""}
                  {...register("streetAddres")}
                />
              </div>
              {errors?.streetAddres ? (
                <p className='error-text'>{errors?.streetAddres?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className='resource-dev-input'>
              <label>Job Role</label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='jobRole'
                  placeholder='Role'
                  className={errors.Name ? "error-field" : ""}
                  {...register("jobRole")}
                />
              </div>
              {errors?.jobRole ? (
                <p className='error-text'>{errors?.jobRole?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <div className='resource-form'>
            <span>Experience</span>
          </div>
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Month</label>
              <select >
                <option value='' disabled>
                  Select option
                </option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
                <option value='5'>5</option>
                <option value='6'>6</option>
                <option value='7'>7</option>
                <option value='8'>8</option>
                <option value='9'>9</option>
                <option value='10'>10</option>
                <option value='11'>11</option>
                <option value='12'>12</option>
              </select>
              {/* {errors?.month ? (
                <p className='error-text'>{errors.month.message}</p>
              ) : (
                ""
              )} */}
            </Form.Group>

            <Form.Group className='resource-dev-input'>
              <label>Year</label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='experience'
                  placeholder='3+ Experience'
                  className={errors.Name ? "error-field" : ""}
                  {...register("experience")}
                // onChange={(e) => handleChange(e.target.value)}
                />
                {/* <img src={name} alt='name' /> */}
              </div>
              {errors?.experience ? (
                <p className='error-text'>{errors?.experience?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <div className='address-content' id='address'>
            <Form.Group className='form-group'>
              <div className='resource-dev-input'>
                <label>Country </label>

                <Select
                  classNamePrefix='react-select'
                  styles={customStyles}
                  options={Country.getAllCountries()}
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedCountry}
                  onChange={(item) => {
                    setSelectedCountry(item);
                  }}
                />
              </div>
            </Form.Group>
            <Form.Group className='form-group'>
              <div className='resource-dev-input'>
                <label>State </label>
                <Select
                  classNamePrefix='react-select'
                  styles={customStyles}
                  options={State?.getStatesOfCountry(selectedCountry?.isoCode)}
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedState}
                  onChange={(item) => {
                    setSelectedState(item);
                  }}
                />
                
              </div>
            </Form.Group>
            <Form.Group className='form-group'>
              <div className='resource-dev-input'>
                <label>City </label>
                <Select
                  classNamePrefix='react-select'
                  styles={customStyles}
                  options={City.getCitiesOfState(
                    selectedState?.countryCode,
                    selectedState?.isoCode
                  )}
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedCity}
                  onChange={(item) => {
                    setSelectedCity(item);
                  }}
                />
              </div>
            </Form.Group>
          </div>
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Job Description</label>
              <textarea
                placeholder='Lorem Ipsum'
                name='jobDescription'
              className={errors.jobDescription ? "error-field" : ""}
              {...register("jobDescription")}
              />
              {errors?.jobDescription ? (
                <p className='error-text'>{errors?.jobDescription?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <NextBtn handleStepChange={handleStepChange} check={check} />
        </div>
      </Form>
    </div>
  );
};

export default StepFirst;
